import { createClient } from "@supabase/supabase-js";
import { env, isConfigured } from "./env";

export const supabase = isConfigured
  ? createClient(env.supabaseUrl, env.supabaseAnonKey, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } })
  : null;

export function requireSupabase() {
  if (!supabase) throw new Error("ยังไม่ได้ตั้งค่า Supabase สำหรับ Attendance");
  return supabase;
}
